import "./utilities_namespace.js";

window.Sparkle ??= {};
window.Sparkle.Embed ??= {};
window.Sparkle.Embed.Utilities ??= {};

Sparkle.Embed.Utilities.TranslationObserver = (function ($) {
  "use strict";

  var CONFIG = {
    attributes: false,
    subtree: true,
    childList: true,
  };

  function updateNonTranslatedContent(container, mutations, observer) {
    for (var mutation of mutations) {
      if (mutation.type === "childList" && mutation.addedNodes.length !== 0) {
        jQuery(container).find("[translate=no]").addClass("notranslate");
      }
    }
  }

  function observe(elementOrSelector) {
    var element = jQuery(elementOrSelector)[0];
    if (!element) {
      console.warn("Could not find element", elementOrSelector);
      return;
    }
    var observer = new MutationObserver(function (mutations, observer) {
      updateNonTranslatedContent(element, mutations, observer);
    });
    observer.observe(element, CONFIG);
    return observer;
  }

  return {
    observe: observe,
  };
})(jQuery);
